import React, { useEffect, useState } from "react";

import {
  FaPlus,
  FaFilter,
  FaTrash,
  FaEdit,
  FaEye,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";

import AppPagination from "../components/AppPagination";

import CustomerModal from "../components/Modals/CustomerModal";

import DeleteModal from "../components/Modals/DeleteModal";

const Customer = () => {
  // Modal States
  const [showCustomerModal, setShowCustomerModal] = useState(false);

  const [viewMode, setViewMode] = useState(false);

  const [editData, setEditData] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteId, setDeleteId] = useState(null);

  // Filter
  const [showFilter, setShowFilter] = useState(false);

  const [loading, setLoading] = useState(true);
    useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);


  // Customer Data
  const customerData = [
    {
      id: 1,
      customer_name: "Amit Sharma",
      company_name: "AS Tech",
      phone: "9876543210",
      email: "amit@gmail.com",
      gst_number: "08ABCDE1234F1Z5",
      customer_type: "Regular",
      status: "Active",
    },

    {
      id: 2,
      customer_name: "Rahul Verma",
      company_name: "RV Solutions",
      phone: "9988776655",
      email: "rahul@gmail.com",
      gst_number: "08PQRSX5678L1Z2",
      customer_type: "Wholesale",
      status: "Inactive",
    },

    {
      id: 3,
      customer_name: "Sonia Mehta",
      company_name: "SM Enterprises",
      phone: "8899776655",
      email: "sonia@gmail.com",
      gst_number: "08LMNOP9876Q1Z7",
      customer_type: "Retail",
      status: "Active",
    },
  ];

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 5;

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = customerData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(customerData.length / itemsPerPage);

  // Delete
  const handleDelete = () => {
    console.log(deleteId);

    setShowDeleteModal(false);
  };

  return (
    <div className="lead-page">
      {/* Header */}
      <div className="lead-header">
        <div>
          <h2 className="mb-1">Customer</h2>
        </div>

        <button
          className="btn btn-primary"
          onClick={() => {
            setEditData(null);
            setViewMode(false);
            setShowCustomerModal(true);
          }}
        >
          <FaPlus className="me-1" />
          Add Party
        </button>
      </div>

      {/* Card */}
      <div className="card mb-4 card-light">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="card-title mb-0">All Customer List</h5>

          <div className="d-flex gap-2 align-items-center">
            {showFilter && (
              <input
                type="text"
                className="form-control"
                placeholder="Search Customer"
              />
            )}

            <button
              className="btn btn-dark"
              onClick={() => setShowFilter(!showFilter)}
            >
              <FaFilter className="me-1" />
              Filter
            </button>
          </div>
        </div>

        <div className="card-body">
        <div className="table-outer border">
          <div className="table-responsive">
            <table className="table m-0 align-middle">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Customer</th>
                  <th>Company</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>GST Number</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="9" className="text-center py-4">
                      Loading...
                    </td>
                  </tr>
                ) : currentItems.length > 0 ? (
                  currentItems.map((item) => (
                    <tr key={item.id}>
                      <td>#{item.id}</td>

                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <span className="fw-semibold">
                            {item.customer_name}
                          </span>
                        </div>
                      </td>

                      <td>{item.company_name}</td>

                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <FaPhoneAlt size={12} />
                          {item.phone}
                        </div>
                      </td>

                      <td>
                          {item.email}
                      </td>

                      <td>{item.gst_number}</td>

                      <td>
                        <span className="badge bg-info">
                          {item.customer_type}
                        </span>
                      </td>

                      <td>
                        <span
                          className={`badge ${
                            item.status === "Active"
                              ? "bg-success"
                              : "bg-danger"
                          }`}
                        >
                          {item.status}
                        </span>
                      </td>

                      <td>
                        <div className="d-flex gap-2">
                          {/* View */}
                          <button
                            className="btn btn-sm btn-info custum_primary"
                            onClick={() => {
                              setEditData(item);
                              setViewMode(true);
                              setShowCustomerModal(true);
                            }}
                          >
                            <FaEye />
                          </button>

                          {/* Edit */}
                          <button
                            className="btn btn-sm btn-info custum_edit text-white"
                            onClick={() => {
                              setEditData(item);
                              setViewMode(false);
                              setShowCustomerModal(true);
                            }}
                          >
                            <FaEdit />
                          </button>

                          {/* Delete */}
                          <button
                            className="btn btn-sm btn-info custum_danger"
                            onClick={() => {
                              setDeleteId(item.id);
                              setShowDeleteModal(true);
                            }}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-4">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          </div>

          {/* Pagination */}
          <div className="row mt-2 p-2">
            <div className="col-md-12">
              <AppPagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={customerData.length}
                itemsPerPage={itemsPerPage}
                onPageChange={setCurrentPage}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Customer Modal */}
      <CustomerModal
        show={showCustomerModal}
        setShow={setShowCustomerModal}
        editData={editData}
        viewMode={viewMode}
      />

      {/* Delete Modal */}
      <DeleteModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        onConfirm={handleDelete}
        title="Delete Customer?"
        message="Are you sure you want to delete this customer?"
      />
    </div>
  );
};

export default Customer;
